export const PLATFORM_FEE = {
  FREE: 0.15,
  LITE: 0.05,
  PRO: 0.0,
};

export const TRANSACTION_FEE = 0.03;
export const FLAT_PRICING = 'flat';
export const HOSTING_PLUS_PER_PERSON = 'hosting_plus_per_person';

export function getExchangeRate() {
  const metaExchangeRate = document.querySelector('meta[name="exchange-rate"]');
  return Number.parseFloat(metaExchangeRate ? metaExchangeRate.content : 1);
}

export function getCurrency() {
  const metaCurrency = document.querySelector('meta[name="currency"]');
  return metaCurrency ? metaCurrency.content : 'USD';
}

export function getLocale() {
  return new Intl.NumberFormat().resolvedOptions().locale;
}

export function formatPriceForSelectedCurrency(price) {
  const formatter = new Intl.NumberFormat(getLocale(), {
    style: 'currency',
    currency: getCurrency(),
    useGrouping: true,
    currencyDisplay: 'symbol',
  });
  return formatter.format(price * getExchangeRate());
}

export function getPricingForParticipants(pricingTiers, participantCount, chargePlatformFee, withKit = false) {
  let participants = Number.parseInt(participantCount, 10) || null;

  let minParticipants = Infinity;
  let maxParticipants = -Infinity;
  const { kind } = pricingTiers;

  function tierForParticipants(tiers) {
    return tiers.find(
      (t) => {
        const { min_participants: min, max_participants: max } = t;
        if (minParticipants > min) {
          minParticipants = min;
        }
        if (maxParticipants < max) {
          maxParticipants = max;
        }
        return participants >= min && participants <= max;
      },
    );
  }

  const tier = !participants ? (pricingTiers.tiers[0]) : tierForParticipants(pricingTiers.tiers);

  if (!tier) {
    return {
      hostingFee: null,
      price: null,
      displayPrice: null,
      subtotal: null,
      platformFee: null,
      kitPrice: null,
      participantSubtotal: null,
      kitSubtotal: null,
      total: null,
      valid: false,
      kind,
      minParticipants,
      maxParticipants,
    };
  }

  const kitPrice = tier ? tier.kit_price || 0 : 0;
  const kitSubtotal = withKit ? (kitPrice * participants) : 0;

  if (kind === FLAT_PRICING) {
    participants = 1;
  }
  const hostingFee = tier && tier.hosting_fee ? tier.hosting_fee : 0;
  const price = tier ? tier.price : 0;
  const displayPrice = tier ? tier.price : pricingTiers.display_price;
  const participantSubtotal = (price * participants);
  const subtotal = hostingFee + participantSubtotal + kitSubtotal;
  const platformFee = ((subtotal) * chargePlatformFee);
  const transactionFee = (subtotal + platformFee) * TRANSACTION_FEE;
  minParticipants = tier.min_participants;
  maxParticipants = tier.max_participants;

  let total = subtotal + transactionFee;

  if (chargePlatformFee) {
    total += platformFee;
  }

  return {
    kind,
    hostingFee,
    price,
    displayPrice,
    subtotal,
    platformFee,
    transactionFee,
    kitPrice,
    participantSubtotal,
    kitSubtotal,
    valid: true,
    total,
    minParticipants,
    maxParticipants,
  };
}

export function formatPrice(price, currency = 'USD') {
  let formattingPrice = price;
  const formatter = Intl.NumberFormat(
    Intl.DateTimeFormat().resolvedOptions().locale,
    {
      style: 'currency',
      currency: currency.toUpperCase(),
      minimumFractionDigits: 2,
    },
  );
  if (formattingPrice === null || formattingPrice === undefined || Number.isNaN(formattingPrice)) {
    formattingPrice = 0;
  }

  return formatter.format(formattingPrice);
}
